module.exports = __webpack_public_path__ + "assets/img/instagram-footer.952729af.svg";